import React from "react";
import { NavLink } from "react-router-dom";

// Externals
import classNames from "classnames";
import PropTypes from "prop-types";

// Material helpers
import { withStyles } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

// Material components
import {
  Divider,
  List,
  ListItem,
  ListItemText,
  Collapse
} from "@material-ui/core";

// Component styles
import styles from "./styles";
//menuitems
import menus from "./menuitem";
import multilang from "../../../../language/lang.json";
const Sidebar = ({ classes, className, language: { lang, dir } }) => {
  const rootClassName = classNames(classes.root, className);
  const [flag, setFlag] = React.useState(true);
  const [open, setOpen] = React.useState({
    "1": false,
    "2": false,
    "3": false,
    "4": false
  });

  function handleClick(i) {
    open[i] = !open[i];
    setOpen(open);
    setFlag(!flag);
  }
  return (
    <nav style={{ height: "auto" }} className={rootClassName}>
      <div className={classes.logoWrapper}>
        <NavLink className={classes.logoLink} to="/">
          <img
            alt="logo"
            className={classes.logoImage}
            src="/images/logos/biglogo.png"
          />
        </NavLink>
      </div>
      <Divider className={classes.logoDivider} />
      <List
        disablePadding
        component="nav"
        aria-labelledby="nested-list-subheader"
        className={classes.root}
      >
        {menus.map((item, i) => (
          <div key={i}>
            {item.child.length !== 0 ? (
              <>
                <ListItem
                  button
                  onClick={() => handleClick(i)}
                  className={
                    dir === "rtl" ? classes.listItem : classes.listItemLtr
                  }
                >
                  <ListItemText
                    primary={multilang[item.code][lang]}
                    className={classes.itemtext}
                    disableTypography={true}
                  />
                  {item.child.length !== 0 ? (
                    open[i] ? (
                      <ExpandLess className={classes.svgitem} />
                    ) : (
                      <ExpandMore className={classes.svgitem} />
                    )
                  ) : (
                    ""
                  )}
                </ListItem>
                {item.child.length !== 0 && (
                  <Collapse in={open[i]} timeout="auto" unmountOnExit>
                    {item.child.map((el, i) => (
                      <NavLink
                        to={el.link}
                        key={i}
                        activeClassName={classes.activeListItem}
                      >
                        <ListItem
                          className={
                            dir === "rtl"
                              ? classes.listItem
                              : classes.listItemLtr
                          }
                        >
                          {/* <ListItemIcon>
                        <el.icon />
                      </ListItemIcon> */}
                          <ListItemText
                            classes={{ primary: classes.listItemText }}
                            primary={multilang[el.code][lang]}
                          />
                        </ListItem>
                      </NavLink>
                    ))}
                  </Collapse>
                )}
              </>
            ) : (
              <NavLink
                to={item.link}
                key={i}
                activeClassName={classes.activeListItem}
              >
                <ListItem
                  button
                  onClick={() => handleClick(i)}
                  className={
                    dir === "rtl" ? classes.listItem : classes.listItemLtr
                  }
                >
                  <ListItemText
                    primary={multilang[item.code][lang]}
                    className={classes.itemtext}
                    disableTypography={true}
                  />
                </ListItem>
              </NavLink>
            )}
          </div>
        ))}
      </List>
    </nav>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Sidebar);
